import hydraulicDataConfig from '@/api/config/hydraulicDataConfig'
import { queryKeys } from '@/constant/common'
import { FormPipe } from '@/types/hydraulic'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'
import { useConfigUI } from '../../context'
import { getApiErrorMessage } from '@/helpers'

async function updatePipe(payload: FormPipe): Promise<void> {
  await hydraulicDataConfig.update(payload)
}

function useEditHydraulic(parentId?: number) {
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation((payload: FormPipe) => updatePipe(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.hydraulic])
      toast.success(!!parentId ? 'Edit Sub Pipe Success' : 'Edit Pipe Success')
      closeSidebar()
    },
    onError: (error: any) => {
      toast.error(getApiErrorMessage(error))
    },
  })
}

export default useEditHydraulic
